import React from 'react';

import {
  Box,
  Button,
  Stack,
  TextField
} from '@mui/material';
import _ from 'lodash';
import {
  authService,
  BaseOnboardingTemplate,
  routeDirectory,
  useStringQueryValue
} from 'modules';
import {
  Controller,
  useForm
} from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import * as dataService from './dataService';



const __formSchema = yup.object({
  code: yup.string()
    .min(6, 'Code must be no less than 6 characters')
    .max(6, 'Code must be no more than 6 characters')
    .required('Code is a required field.')
}).required();

type IFormData = yup.InferType<typeof __formSchema>;



export const ConfirmCodeActivity: React.FC = () => {
  const navigate = useNavigate();

  const email = useStringQueryValue({
    key: 'email',
    fnPreProcess: val => _.replace(val, /\+/, '%2B')
  });

  const { mutations, loading } = dataService.useConfirmCodeActivity();
  const { control, handleSubmit } = useForm<{code: string}>({
    defaultValues: { code: '' }
  });



  async function processSubmit(data: IFormData) {
    try {
      await mutations.confirmCode(email, data.code);
      navigate(routeDirectory.home.path());

    } catch (e) {
      console.log(e);
      // TODO: Handle Amplify errors
      if ((e as Error).name === 'ExpiredCodeException') {
        alert('Code is expired or invalid. We resent the confirmation code again. Please use this code to complete logging in.');
        await authService.resendRegisterCode(email);

      } else if ((e as Error).name === 'CodeMismatchException') {
        alert('Code doesn\'t match. Please try again.');

      } else if ((e as Error).name === 'MISSING_SIGN_UP_AUTH_DATA') {
        navigate(routeDirectory.authentication.login.path());

      } else {
        alert((e as Error).message);
      }
    }
  }



  return (
    <BaseOnboardingTemplate.FC
      stepperMode="none"
      title="Confirm Code"
      subtitle={`We sent a confirmation email to ${email} with a verification code. Please enter that code here to continue. If you do not see the email in your primary inbox, please check your spam folder.`}>
      <Stack spacing={3}>
        <form
          onSubmit={handleSubmit(processSubmit)}
          autoComplete="off">
          <Stack
            direction="row"
            alignItems="center"
            spacing={3}>
            <Controller
              name="code"
              control={control}
              rules={{ required: 'Code is a required field' }}
              render={({ field }) => (
                <TextField
                  label="Code"
                  fullWidth
                  disabled={loading}
                  value={field.value}
                  onChange={field.onChange} />
              )} />

            <Box>
              <Button
                type="submit"
                color="primary"
                disabled={loading}>
                Confirm
              </Button>
            </Box>
          </Stack>

        </form>
      </Stack>
    </BaseOnboardingTemplate.FC>
  );
};
